module.exports = __webpack_public_path__ + "static/falstaff-logo-ff2956275171ec10dd9046afa7d793b0.svg";